import React, { useState, useEffect } from "react";

export default function CheckBoxGroup({
  url, state, setState, post_attr, display_attr, display_attr_2 }) {
    
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(url)
      .then((response) => response.json())
      .then((json) => json.sort((itemA, itemB) =>  itemA.id - itemB.id))
      .then((json) => setData(json));
  }, [url])

  const [complete, setComplete] = useState(false);

  let CheckBoxGroup = [];

  for (var i = 0; i < data.length; i++) {
    let record = data[i];

    CheckBoxGroup.push(
      <div key={record["id"]} className="form-check pl-2"
        style={!complete && i >= 5 ? {display: "none"} : {display: "block"}}>

        <label className="form-check-label h6">
          {record[display_attr] ? record[display_attr] : record[display_attr_2]}

          <input data-testid={`checkbox-${record["id"]}`}
            className="form-check-input" type="checkbox"
            checked={state.includes(record[post_attr])}

            onChange={(e) => {
              const checked = state.includes(record[post_attr]);
              setState(prev => checked ? prev.filter(cat => cat !== record[post_attr]) : [...prev, record[post_attr]]);
            }}
          />
        </label>
      </div>
    )
  }

  return (
    <div>
      {CheckBoxGroup}
      <button className="h6 lihat pt-2" alt="button-lihat"
        onClick={(e) => {
          for (var i = 5; i < data.length; i++) {
            CheckBoxGroup[i] = {...CheckBoxGroup[i], style:`{display: {complete ? "none" : "block"}}`}
          }
          setComplete(!complete);
        }}>
        {complete ? "Lihat Lebih Sedikit" : "Lihat Selengkapnya"}
      </button>
    </div>
  )

}
